
function get(route, Dataparams) {
    return jQuery.ajax({
        url: window.ajaxurl,
        type: 'GET',
        data: {
            ...Dataparams,
            action: 'wpb_ajax_get',
            route_name: route
        }
    })
}

function post(route, Dataparams) {

    let isFormData = {
        processData: false,
        contentType: false
    }
    if (Dataparams instanceof FormData) {
        Dataparams.append('action', 'wpb_ajax_post');
        Dataparams.append('route_name', route);

    } else {
        Dataparams = {
            ...Dataparams, 
            action: 'wpb_ajax_post',
            _ajax_nonce: window?.wpbookit?._ajax_nonce ?? wpb_nounce,
            route_name: route
        };
    }


    return jQuery.ajax({
        url: window.ajaxurl,
        type: 'POST',
        data: Dataparams,
        ...(Dataparams instanceof FormData)?isFormData:{}
    })
}
export { get, post } 